export default "__VITE_ASSET___app/immutable/assets/light-green-pointer-cursor.aktC_UvX.svg__"